export var KafkaStartingOffset;
(function (KafkaStartingOffset) {
    KafkaStartingOffset["KAFKA_STARTING_OFFSET_EARLIEST"] = "earliest";
    KafkaStartingOffset["KAFKA_STARTING_OFFSET_LATEST"] = "latest";
})(KafkaStartingOffset || (KafkaStartingOffset = {}));
